import 'antd/dist/antd.min.css';
import 'antd-mobile/es/global/global.css';
import './styles/App.less';
import 'mapbox-gl/dist/mapbox-gl.css';
import { useMemo } from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { checkIsTherapist } from 'helpers/checkIsTherapist';
import { BrowserRouter as Router } from 'react-router-dom';
import Theme from 'components/theme';
import LangContextProvider from './context/LangContextProvider';
import AppRoutes from './AppRoutes';
import NotifyResultStyled from './components/global/styled/NotifyResultStyled';
import { useOneSignal } from './hooks/useOneSignal';

function App() {
    const isTherapist = checkIsTherapist();
    const queryClient = useMemo(
        () =>
            new QueryClient({
                defaultOptions: {
                    queries: {
                        refetchOnWindowFocus: false,
                    },
                },
            }),
        []
    );

    const guestAppId = process.env.REACT_APP_ONESIGNAL_GUEST_APP_ID;
    const therapistAppId = process.env.REACT_APP_ONESIGNAL_THERAPIST_APP_ID;

    const appId = useMemo(() => (isTherapist ? therapistAppId : guestAppId), [isTherapist]);

    useOneSignal(appId);

    return (
        <QueryClientProvider client={queryClient}>
            <LangContextProvider>
                <Router>
                    <NotifyResultStyled />
                    {/* <NotificationHandler /> */}
                    <Theme>
                        <AppRoutes />
                    </Theme>
                </Router>
            </LangContextProvider>
        </QueryClientProvider>
    );
}

export default App;
